import {useSelectCityModalStore} from "../model/store";
import {useLocation} from "@/entities/location";
import {Svg} from "@/shared/ui/Svg";
import styles from "./CitySelector.module.scss";

export const CitySelector = () => {
    const openModal = useSelectCityModalStore(s => s.actions.openModal);
    const city = useLocation(s => s.location.city);

    return (
        <button
            type="button"
            className={styles.city}
            onClick={openModal}
        >
            <Svg id={`location`} className={styles.cityIcon} />

            <span className={styles.cityText}>{city}</span>
        </button>
    );
};
